import { Col, Text } from 'components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  margin: ${(props) => (props.marg ? props.marg : '0')};
  cursor: pointer;

  .teamName {
    font-size: 24px;
    margin: 11px 0 0;
  }

  @media (max-width: 1024px) {
    .teamName {
      font-size: 16px;
      margin: 9px 0 0;
    }
  }
`;

const ImageBackground = styled.div`
  background: url(${(props) => props.img});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: ${(props) => (props.admin ? '330px' : '510px')};
  width: ${(props) => (props.admin ? '330px' : '510px')};

  @media (max-width: 1024px) {
    background: url(${(props) => props.img});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    height: ${window.innerWidth - 35}px;
    width: ${window.innerWidth - 35}px;
    ${(props) => props.mobileMode && 'height: 312px; width: 312px;'}
  }
`;

const TeamBox = ({ item, col, marg, mobileMode, admin }) => {
  const { t } = useTranslation(),
    navigate = useNavigate();

  return (
    <Container
      className="team-box"
      marg={marg}
      onClick={() => navigate(`/profile/${item.username}`)}
    >
      <ImageBackground
        className="team-box-image"
        mobileMode={mobileMode}
        admin={admin}
        img={item.avatar || require('assets/images/team-placeholder.png')}
      >
        {mobileMode && (
          <Col ht="100%" between>
            <div />

            <Text size="72px" lineHt="54px" bold stencil col={col || '#fff'}></Text>
          </Col>
        )}
      </ImageBackground>

      {!mobileMode && (
        <Text col={col || '#fff'} className="teamName">
          {item.name}
        </Text>
      )}
    </Container>
  );
};

export default TeamBox;
